import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { defaultPageInfo, defaultPaging } from '@/common/constants/ConstCode';

const state = {
  condition: {
    ...defaultPaging,
    userNo: '',
    searchType: ''
  },
  pageInfo: { ...defaultPageInfo },
  list: [],
  detail: ''
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
